import { cn } from "@/components/common"

const Divider = ({ className }: { className?: string }) => (
  <div
    className={cn("h-px w-full border-b border-border mt-1", className)}
  />
)

export default Divider
